import { createRESTStore } from "@stores/shared/createRESTStore";
import API from "@config/shared/api-paths";

const useZonesStore = createRESTStore({
  entityName: "zones",
  apiPaths: {
    fetch: API.BASE + API.FRONTEND.ZONES,
  },
  // null until the request answers: [] then means the tenant really has no zones.
  initialState: null,
  processResponse: {
    fetch: (response) => response.items,
  },
});

export default useZonesStore;
